import { ArrowRight, Megaphone } from 'lucide-react'
import { Link } from 'react-router-dom'

export function AnnouncementCard({ announcement }) {
  return (
    <article className="announcement-card">
      <div className="announcement-card__icon"><Megaphone size={21} /></div>
      <div>
        <p className="announcement-card__meta">{announcement.category} · {announcement.date}</p>
        <h3>{announcement.title}</h3>
        <p>{announcement.summary}</p>
        <Link to={announcement.to} className="text-link">Read more <ArrowRight size={16} /></Link>
      </div>
    </article>
  )
}
